import React, { useState, useEffect } from "react";
import {
  Backdrop,
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
  CircularProgress,
} from "@mui/material";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import LogoutIcon from "@mui/icons-material/Logout";
import { styled, Container } from "@mui/system";
import { Link, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import Logo from "../Assets/Logo/logo2.svg";
import todaysContest from "../Assets/todaysContest.jpg";
import lockImage from "../Assets/lock.png";
import { useUserDetailsQuery } from "../../app/services/userCore";
import { ToastContainer, toast } from "react-toastify";

const CardContents = styled(CardContent)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  color: "#F4F4FF",
  minHeight: "25rem",
  maxHeight: "25rem",
  padding: "2rem",
});

const subjects = {
  INTRODUCTION: "Introductory videos",
  DSA: "Data Structures and Algorithm",
  PYTHON: "Python",
  OS: "Operating Systems",
  CN: "Computer Networks",
  DBMS: "Database Management System",
  OOPS: "Object Oriented Programming",
  APTITUDE: "Aptitude",
  INTERNSHIP: "SDE Internship",
};

const colors = [
  "#4267ff",
  "#fb9f15",
  "#ff4242",
  "#36486b",
  "#4267ff",
  "#fb9f15",
  "#ff4242",
  "#36486b",
  "#4267ff",
];

function sortObject(obj) {
  return Object.keys(obj)
    .sort()
    .reduce(function (result, key) {
      result[key] = obj[key];
      return result;
    }, {});
}

const HomeDashboard = () => {
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies([
    "username",
    "o1HybridUser",
  ]);
  const name = cookies.username;
  const [content, setContent] = useState({
    INTRODUCTION: {},
    DSA: {},
    PYTHON: {},
    OS: {},
    CN: {},
    DBMS: {},
    OOPS: {},
    APTITUDE: {},
    INTERNSHIP: {},
  });

  const handleLogOut = () => {
    toast.info("Logging you out and redirecting to home page.", {
      toastId: "logoutSuccess",
      onClose: () => {
        removeCookie("o1HybridUser");
        localStorage.removeItem("o1HybridUser");
        removeCookie("username");
        localStorage.removeItem("username");
        navigate("/");
      },
    });
  };

  const handleNavigate = (subj) => {
    if (
      content[subj] === undefined ||
      content[subj] === null ||
      content[subj]["status"] === 0
    ) {
      toast.error("The current section is locked.", {
        toastId: `sectionLocked-${subj}`,
      });
      return;
    }
    const upperSubj = subj.toUpperCase();
    navigate(`/dashboard/${upperSubj}`);
  };

  const formatContent = (contentObj) => {
    const sortedContent = sortObject(contentObj);
    const formattedContent = {
      INTRODUCTION: sortedContent["INTRODUCTION"],
    };
    delete sortedContent["INTRODUCTION"];
    Object.keys(sortedContent).map((key, index) => {
      formattedContent[key] = sortedContent[key];
    });
    return formattedContent;
  };

  const { data, isLoading, isSuccess, isError, error } = useUserDetailsQuery();

  useEffect(() => {
    if (isSuccess) {
      setContent(formatContent(data?.data?.content));
    } else if (isError) {
      if (error?.data?.message === "Authorization token missing") {
        handleLogOut();
        return;
      }
      toast.error(
        error?.data?.message || "Unable to get user details. Contact Admin!",
        {
          toastId: "error",
        }
      );
    }
  }, [isSuccess, isError]);

  return (
    <div>
      {isLoading ? (
        <>
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1000,
            }}
            open={true}
          >
            <CircularProgress color="secondary" />
          </Backdrop>
        </>
      ) : (
        <Container maxWidth="xl" sx={{ margin: "1rem 0" }}>
          <Grid
            container
            spacing={5}
            alignItems={"flex-start"}
            justifyContent={"center"}
            sx={{ marginBottom: "1rem" }}
          >
            <Grid item xs={12} md={12}>
              <Box
                sx={{
                  background: "#0F143C",
                  borderRadius: "0.3rem",
                  position: "relative",
                }}
              >
                <Link to="/home" style={{ position: "absolute", top: 0 }}>
                  <Box
                    sx={{
                      width: "3.6rem",
                      transform: "translate(28px, 11.7px)",
                      "@media (max-width: 560px)": {
                        width: "2.45rem",
                        transform: "translate(12px, 14.7px)",
                      },
                    }}
                  >
                    <img
                      className="brand-logo"
                      src={Logo}
                      alt="O(1) Coding Club"
                      srcSet=""
                      style={{ width: "100%" }}
                    />
                  </Box>
                </Link>
                <Typography
                  variant="h4"
                  sx={{
                    padding: "1.22rem 0",
                    color: "white",
                    textAlign: "center",
                    fontFamily: "'Rubik', sans-serif",
                    fontWeight: 500,
                    "@media (max-width: 560px)": {
                      fontSize: "1.45rem",
                    },
                    "@media (max-width: 390px)": {
                      fontSize: "1.25rem",
                    },
                  }}
                >
                  SmartLearn
                </Typography>
                <Box
                  sx={{
                    display: window.innerWidth <= 760 ? "none" : "",
                    top: "1.2rem",
                    right: "12px",
                    position: "absolute",
                    "@media (max-width:500px)": {
                      top: "1.1rem",
                      right: 0,
                    },
                  }}
                >
                  <Button
                    className="mr-3"
                    sx={{
                      backgroundColor: "#6f63e6",
                      minWidth: "initial",
                      "@media (max-width:500px)": {
                        padding: " 2px 3px",
                        fontSize: "0.71rem",
                      },
                    }}
                    variant="contained"
                    onClick={() => handleLogOut()}
                  >
                    Logout
                    <LogoutIcon
                      style={{
                        marginLeft: "0.2rem",
                        paddingLeft: "0.2rem",
                      }}
                    />
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>

          <Grid container spacing={2} rowSpacing={3} columnSpacing={3}>
            <Grid item xs={12} sm={6} md={4}>
              <Card
                sx={{
                  boxShadow: 1,
                  minWidth: 275,
                  cursor: "pointer",
                  backgroundColor: "#6F63E6",
                }}
              >
                <CardContents className="user-detail">
                  <EmojiPeopleIcon
                    sx={{
                      boxShadow: 2,
                      fontSize: "4rem",
                      borderRadius: "2rem",
                      backgroundColor: "#7468F0",
                      padding: "0.3rem",
                    }}
                  />
                  <h2> Hello, {name} </h2>
                  <p> Nice to meet you ! </p>
                </CardContents>
              </Card>
            </Grid>

            {Object.keys(content).map((subj, index) => {
              return (
                content[subj]["status"] === 1 && (
                  <Grid item xs={12} sm={6} md={4}>
                    <Box
                      sx={{
                        transition: "0.2s",
                        "&:hover": {
                          transform: "scale(1.02)",
                        },
                      }}
                      onClick={() => handleNavigate(subj)}
                    >
                      <Card
                        className="overall-analysis"
                        sx={{
                          boxShadow: 2,
                          minWidth: 275,
                          cursor: "pointer",
                          backgroundColor: colors[index],
                          textAlign: "center",
                        }}
                      >
                        <CardContents className="user-detail">
                          <div
                            style={{
                              borderRadius: "50%",
                              background: "#000",
                              marginRight: "auto",
                              marginLeft: "auto",
                              marginBottom: "4%",
                              height: "100px",
                              width: "100px",
                            }}
                          >
                            <img
                              src={
                                content[subj]["status"] === 0
                                  ? lockImage
                                  : todaysContest
                              }
                              alt="Coding Section"
                              style={{ borderRadius: "50%" }}
                              height={"100%"}
                              width={"100%"}
                            />
                          </div>
                          <h2>{subjects[subj]}</h2>
                        </CardContents>
                      </Card>
                    </Box>
                  </Grid>
                )
              );
            })}
          </Grid>

          <ToastContainer
            position="bottom-right"
            autoClose={2000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            theme="colored"
            pauseOnHover
          />
        </Container>
      )}
    </div>
  );
};

export default HomeDashboard;
